import { PublicReview } from '@shared/types';
import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import styles from './styles.module.scss';

const Badge: FunctionComponent<PropsWithChildren<{ className?: string }>> = ({
    className,
    children,
}) => {
    return <div className={classNames(styles.badge, className)}>{children}</div>;
};

const VerifiedBadge: FunctionComponent<{
    verified: PublicReview['verified'];
    sourceKey: PublicReview['sourceKey'];
}> = ({ verified, sourceKey }) => {
    const label = useMemo(() => (verified ? 'verified' : 'unverified'), [verified]);

    if (['facebook', 'googlemaps'].includes(sourceKey)) {
        return null;
    }

    return <Badge className={styles[label]}>{label}</Badge>;
};

export default VerifiedBadge;
